
import { UserProfile } from "@/types/profile";
import { UseFormRegister } from "react-hook-form";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface PerformerProfileFormProps {
  register: UseFormRegister<UserProfile>;
}

export const PerformerProfileForm = ({ register }: PerformerProfileFormProps) => {
  const currencies = [
    { value: "USD", label: "USD - US Dollar" },
    { value: "EUR", label: "EUR - Euro" },
    { value: "GBP", label: "GBP - British Pound" },
    { value: "JPY", label: "JPY - Japanese Yen" },
    { value: "AUD", label: "AUD - Australian Dollar" },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle>Performer Profile</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="bio">Bio</Label>
          <Textarea
            id="bio"
            {...register("bio")}
            placeholder="Share your story, style, and experience..."
            className="min-h-[100px]"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="stage_name">Stage Name</Label>
          <Input
            id="stage_name"
            {...register("stage_name")}
            placeholder="Your performance name"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="years_experience">Years of Experience</Label>
          <Input
            id="years_experience"
            type="number"
            {...register("years_experience", { valueAsNumber: true })}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="preferred_currency">Preferred Currency</Label>
          <Select defaultValue="USD">
            <SelectTrigger id="preferred_currency" className="w-full">
              <SelectValue placeholder="Select currency" />
            </SelectTrigger>
            <SelectContent>
              {currencies.map((currency) => (
                <SelectItem key={currency.value} value={currency.value}>
                  {currency.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="travel_flexibility">Travel Flexibility</Label>
          <Input
            id="travel_flexibility"
            {...register("travel_flexibility")}
            placeholder="e.g., 'Willing to travel within 50 miles'"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="booking_policy">Booking Policy</Label>
          <Textarea
            id="booking_policy"
            {...register("booking_policy")}
            placeholder="Describe your booking terms and conditions..."
            className="min-h-[100px]"
          />
        </div>
      </CardContent>
    </Card>
  );
};
